import { h, render } from "preact";
import { useState } from "preact/hooks";
import CompareModalAccordion from "./compareModalAccordion";

export default function CompareModalRow({
  title,
  accordion,
  children,
  className = "",
  titleClassName = "",
}) {
  return (
    <div className={`compare-modal-v2__row ${className}`}>
      {title && (
        <h3 className={`compare-modal-v2__row-title ${titleClassName}`}>
          {title}
        </h3>
      )}
      {accordion ? <CompareModalAccordion children={children} /> : children}
    </div>
  );
}
